var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recommends container content-wrapper",staticStyle:{"padding-top":"10px"}},[_c('div',{staticClass:"head-wrapper"})])
}]

export { render, staticRenderFns }